import React from 'react';
import './ProductCard.css';

function ProductCard({ title, subtitle, src, price, quantity, addToCart}) {
    return (
        <div className='product-card'>
            <div className='card-containing'>
                <div className='card-image'>
                    <img src={src} alt={title} className='fluid-image' />
                    {/* Ensure that addToCart is provided as a prop and called correctly */}
                    <button className='add-to-cart-button' onClick={() => addToCart({title, subtitle, src, price, quantity})} >
                        Add to Cart
                    </button>
                </div>
                <div className='card-details'>
                    <div className='heading-price'>
                        <p className='card-heading'>{title}</p>
                        <p className='price-para'>${price}</p>
                    </div>
                    
                    <hr />

                    <div className='card-subheading-part'>
                        {/* You might want to render the star icon conditionally */}
                        <i className="fa-solid fa-star"></i>
                        <p className='card-subheading'>{subtitle}</p>
                    </div>

                    

                    <div className='text-center' id='invisible-add-to-cart'>
                        <hr />
                        <button className='invisible-add-to-cart-button' onClick={() => addToCart({title, subtitle, src, price, quantity})} >
                            Add to Cart
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProductCard;
